import { Badge, Icon } from '@chakra-ui/react';
import { FaDiscord } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

type PlatformBadgeLiteProps = {
  authorSource?: string | null;
};

function platformMeta(source: string) {
  const key = source.trim().toLowerCase();
  if (key.includes('discord')) {
    return {
      label: 'Discord',
      colorScheme: 'purple' as const,
      Icon: FaDiscord,
    };
  }
  if (key.includes('twitter') || key === 'x') {
    return {
      label: 'X',
      colorScheme: 'gray' as const,
      Icon: FaXTwitter,
      /** Filled black chip, white X glyph. */
      solidBlack: true,
    };
  }
  return {
    label: source,
    colorScheme: 'gray' as const,
    Icon: FaDiscord,
  };
}

export function PlatformBadgeLite({ authorSource }: PlatformBadgeLiteProps) {
  if (!authorSource?.trim()) return null;

  const platform = platformMeta(authorSource);
  const PlatformIcon = platform.Icon;
  const solidBlack = 'solidBlack' in platform && platform.solidBlack;

  return (
    <Badge
      variant="solid"
      colorScheme={solidBlack ? undefined : platform.colorScheme}
      bg={solidBlack ? 'black' : undefined}
      color={solidBlack ? 'white' : undefined}
      display="inline-flex"
      alignItems="center"
      gap={1}
      px={1.5}
      py={0.5}
      borderRadius="full"
      fontSize="10px"
      flexShrink={0}
      title={platform.label}
      aria-label={`Source: ${platform.label}`}
    >
      <Icon
        as={PlatformIcon}
        boxSize={3}
        color={solidBlack ? 'white' : undefined}
      />
    </Badge>
  );
}
